// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useMemo, useState, useContext} from 'react';
import {Card} from './card';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import Icon_arrow_left from '../../img/icons/24/arrow_left.svg';
import {Valid_Line} from './valid_line';
import {Pricing_checks} from './pricing_checks';
import {i_oculus_plans, use_plans} from '../plans/plans';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {oculus_proxy_type} from '../../types';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {product_checks} from '../products';
import hola_opt, {www_hola} from 'hola_opt';
import styles from './buy_cards.module.less';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {App_context} from 'hola_app_context';
import {Modal} from '../../../../hola/pub/lib/modal';
import {Button} from '../../lib/button';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';

const {SDC, DDC, SHARED_ISP, ISPPREM, RES, EV_ISP, EV_RES, SNK} = Proxy_type;
type t_badge = {
    text: string;
    color?: string;
    free?: boolean;
    popular?: boolean;
};

export type t_card_data = {
    badge?: t_badge;
    bandwidth?: null;
    amount: string;
    price: string;
    billed: string;
    plan_id: string;
    period?: string;
};

const free_promo_card: t_card_data = {
    badge: {free: true, text: 'Free'},
    amount: '100 MB',
    price: '$0',
    billed: 'Free for 7 days',
    plan_id: 'free',
};
const badges = {
    [SDC]: {
        oculusv1_shared_dc_lg: {
            popular: true, text: 'Popular', color: 'orchid'
        },
        oculus_shared_dc_1w_100gb: {
            popular: true, text: 'Popular', color: 'orchid'
        },
        oculus_shared_dc_1m_200gb: {
            popular: true, text: 'Popular', color: 'orchid'
        },
    },
    [DDC]: {
        oculusv1_dedicated_dc_xl: {
            popular: true, text: 'Popular', color: 'lavender'
        },
        oculus_dedicated_dc_1w_75ip_7500gb: {
            popular: true, text: 'Popular', color: 'lavender'
        },
        oculus_dedicated_dc_1m_200ip_20000gb: {
            popular: true, text: 'Popular', color: 'lavender'
        },
    },
    [SHARED_ISP]: {
        oculusv1_isp_lg: {
            popular: true, text: 'Popular', color: 'cornflower'
        },
        oculus_isp_1w_30gb: {
            popular: true, text: 'Popular', color: 'cornflower'
        },
        oculus_isp_1m_50gb: {
            popular: true, text: 'Popular', color: 'cornflower'
        }
    },
    [ISPPREM]: {
        oculusv1_isp_plus_lg: {
            popular: true, text: 'Popular', color: 'turquoise'
        },
        oculus_isp_premium_1w_50ip: {
            popular: true, text: 'Popular', color: 'turquoise'
        },
        oculus_isp_premium_1m_100ip: {
            popular: true, text: 'Popular', color: 'turquoise'
        }
    },
    [RES]: {
        oculusv1_smart_resi_lg: {
            popular: true, text: 'Popular', color: 'meadows'
        },
        oculus_residential_rotating_1w_30gb: {
            popular: true, text: 'Popular', color: 'meadows'
        },
        oculus_residential_rotating_1m_50gb: {
            popular: true, text: 'Popular', color: 'meadows'
        }
    },
    [EV_ISP]: {
        oculusv1_events_isp_md_med: {
            popular: true, text: 'Popular', color: 'pink'
        },
        oculusv1_events_isp_sm_short: {
            popular: true, text: 'Popular', color: 'pink'
        },
        oculus_isp_events_e_commerce_1w_25ip: {
            popular: true, text: 'Popular', color: 'pink'
        },
        oculus_isp_events_e_commerce_1m_50ip: {
            popular: true, text: 'Popular', color: 'pink'
        }
    },
    [EV_RES]: {
        oculusv1_events_resi_g_md: {
            popular: true, text: 'Popular', color: 'orange'
        },
        oculus_residential_events_1w_10gb: {
            popular: true, text: 'Popular', color: 'orange'
        },
        oculus_residential_events_1m_20gb: {
            popular: true, text: 'Popular', color: 'orange'
        },
    },
    [SNK]: {
        oculus_residential_sneakers_1w_10gb: {
            popular: true, text: 'Popular', color: 'orange'
        },
        oculus_residential_sneakers_1m_20gb: {
            popular: true, text: 'Popular', color: 'orange'
        },
    },
};
const bandwidth = {
    [DDC]: {
        oculus_dedicated_dc_1m_25ip_2500gb: {text: '2.5 TB Bandwidth'},
        oculus_dedicated_dc_1m_75ip_7500gb: {text: '7.5 TB Bandwidth'},
        oculus_dedicated_dc_1m_200ip_20000gb: {text: '20 TB Bandwidth'},
        oculus_dedicated_dc_1m_100ip: {text: 'Unlimited Bandwidth',
            unlimited: true},
        oculus_dedicated_dc_1w_25ip_2500gb: {text: '2.5 TB Bandwidth'},
        oculus_dedicated_dc_1w_75ip_7500gb: {text: '7.5 TB Bandwidth'},
        oculus_dedicated_dc_1w_200ip_20000gb: {text: '20 TB Bandwidth'},
        oculus_dedicated_dc_1w_100ip: {text: 'Unlimited Bandwidth',
            unlimited: true}
    },
    [ISPPREM]: {
        oculus_isp_premium_1w_30ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1w_50ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1w_100ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1w_200ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1m_30ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1m_50ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1m_100ip: {text: 'Unlimited Bandwidth'},
        oculus_isp_premium_1m_200ip: {text: 'Unlimited Bandwidth'},
    }
};

export const generate_product_cards_data =
(oculus_plans: i_oculus_plans, show_free_zone_promo: boolean)=>{
    const product_cards_data = {};
    Object.entries(oculus_plans.ui_plans).forEach(([key, plan_ids])=>{
        const cards = plan_ids.map(plan_id=>{
            const config = oculus_plans.plans_config[plan_id];
            const plan = oculus_plans.all_plans[key]?.[plan_id];
            if (config && plan)
            {
                const amount = config.ips_amount
                    ? `${config.ips_amount} IPs`
                    : `${config.limit} GB`;
                    const unit = config.unit == 'ip' ? 'IP' : 'GB';
                const price_per_unit = plan.price / (config.ips_amount ||
                    config.limit);
                const price = `$${price_per_unit.toFixed(2)}/${unit}`;
                let billed = plan.price == 0
                    ? 'Free for 14 days'
                    : `$${plan.price} billed`;
                const card_data: t_card_data = {
                    amount,
                    price,
                    billed,
                    plan_id,
                    period: plan.period,
                    badge: null,
                    bandwidth: null
                };
                if (plan.price == 0)
                    card_data.badge = {free: true, text: 'Free'};
                else if (badges[key] && badges[key][plan_id])
                    card_data.badge = badges[key][plan_id];
                if (bandwidth[key] && bandwidth[key][plan_id])
                    card_data.bandwidth = bandwidth[key][plan_id];
                return card_data;
            }
            return null;
        }).filter(Boolean);
        if (key == SDC && show_free_zone_promo)
            cards.unshift(free_promo_card);
        product_cards_data[key] = {
            cards,
            checks: product_checks[key] || []
        };
    });
    return product_cards_data;
};

interface i_readonly_modal_props {
    modal_plan_id: string;
}

export const Readonly_modal = (props: i_readonly_modal_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.modal_content}>
      <img src="https://oculusproxies.com/content/kyc_img.svg"
        alt="Info icon" />
      <p className={cn(theme.p20, theme.bold,
        theme.color_n700)}>Notice: Read-Only Product</p>
      <p className={cn(theme.p16, theme.med,
        theme.color_n600)}>This product is web scraping only, and uses
          real residential IPs for <b> GET requests only</b>. It does
          not support e-commerce purchases, social media management,
          or any data posting. For those activities,
          we recommend our<b> "Sneaker Resis".</b></p>
      <Button cls={styles.i_understand_btn}
        caption={'Continue to purchase'}
        to={`/pricing/checkout?plan_id=${props.modal_plan_id}`}/>
      <Button cls={styles.take_me_btn} color='secondary'
        caption={'Take me to Sneaker Resis'}
        to={get_new_link('/empty/pricing/sneakers')}/>
    </div>;
};

interface i_buy_cards_props {
    product?: string,
    type: oculus_proxy_type,
    with_checks?: boolean;
    current_period?: string;
}

export const Buy_cards = (props: i_buy_cards_props)=>{
    const {theme} = useContext(Settings_context);
    const {is_client} = useContext(App_context);
    const oculus_plans = use_plans();
    const {show_free_zone_promo} = use_app_context();
    const [modal, set_modal] = useState('');
    const [modal_plan_id, set_modal_plan_id] = useState('');
    const {product, type, with_checks = true, current_period} = props;
    const product_cards_data = useMemo(()=>{
        const data =
            generate_product_cards_data(oculus_plans, show_free_zone_promo);
        if (www_hola.pricing_types_with_period
            .includes(type) && current_period)
        {
            data[type].cards = data[type].cards.filter(card=>
                card.period == current_period || card.plan_id == 'free');
        }
        return data;
    }, [oculus_plans, show_free_zone_promo, current_period, type]);
    const short_checks = product == 'ISP Premium';
    const {cards = [], checks = []} = product_cards_data[type] || {};
    const [current_index, set_current_index] = useState(0);
    useEffect(()=>set_current_index(0), [product, current_period]);
    const {width} = use_screen();
    const total_cards = cards.length;
    const card_width = 238;
    const card_gap = 16;
    const max_visible_cards = 4;
    const max_offset = total_cards - max_visible_cards;
    const offset = current_index * (card_width + card_gap);
    const slide_container_width = Math.min(cards.length, max_visible_cards) *
        (card_width + card_gap) - card_gap;
    const handle_right_click = ()=>{
        if (current_index < max_offset)
            set_current_index(prev=>prev + 1);
    };
    const handle_left_click = ()=>{
        if (current_index > 0)
            set_current_index(prev=>prev - 1);
    };
    const handle_set_modal = (id: string, plan_id?: string)=>{
        set_modal(id);
        if (plan_id)
            set_modal_plan_id(plan_id);
    };
    const is_all_sold_out = hola_opt.oculus_zones_availability[type] <
        Math.min(...cards.map(c=>parseInt(c.amount)));
    const is_sold_out = card=>{
        if (type != 'events_isp' && type != 'isp_plus')
            return;
        if (is_all_sold_out)
            return true;
        const amount = parseInt(card.amount);
        return hola_opt.oculus_zones_availability[type] < amount;
    };
    if (!is_client)
        return <div/>;
    return <>
      <div className={styles.cards_container}>
        {is_all_sold_out && <div className={styles.all_sold_out}>
          <p className={cn(theme.p12, theme.color_warn300)}>
            <b>ALL SOLD OUT!</b></p></div>}
        {width > 768 ? <div className={styles.buy_cards}>
          <div className={styles.arrow_box_l}>
            {current_index > 0 && <div className={styles.arrow}
              onClick={handle_left_click}>
              <Icon_arrow_left />
            </div>}
          </div>
          <div className={styles.slides_container}
            style={{width: `${slide_container_width}px`}}>
            <div className={styles.slides} style={{
              width: total_cards * (card_width + card_gap) - card_gap,
              transform: `translateX(-${offset}px)`,}}>
                {cards.map((card, index)=>
                  <Card
                    key={index}
                    amount={card.amount}
                    price={card.price}
                    subtitle={card.billed}
                    bandwidth={card.bandwidth}
                    badge={card.badge}
                    plan_id={card.plan_id}
                    type={type}
                    is_all_sold_out={is_all_sold_out}
                    is_sold_out={is_sold_out(card)}
                    set_modal={handle_set_modal}
                  />
                )}
            </div>
          </div>
          <div className={styles.arrow_box_r}>
            {current_index < max_offset &&
              <div className={styles.arrow} onClick={handle_right_click}>
                <Icon_arrow_right />
              </div>}
          </div>
        </div> :
        <div className={styles.mobile_cards}>
          {cards.map((card, index)=>
            <Card
              mobile
              key={index}
              amount={card.amount}
              price={card.price}
              subtitle={card.billed}
              bandwidth={card.bandwidth}
              badge={card.badge}
              plan_id={card.plan_id}
              type={type}
              is_all_sold_out={is_all_sold_out}
              is_sold_out={is_sold_out(card)}
              set_modal={handle_set_modal}
            />
        )}
        </div>}
        <div className={styles.valid_line}>
          <Valid_Line product={product} period={current_period}/>
        </div>
        {with_checks && <div className={styles.pricing_checks}>
          <Pricing_checks check_list={checks} short_checks={short_checks}/>
        </div>}
        <Modal
          lighter_close_btn={true}
          paddingless={true} width={480}
          is_open={modal === 'read_only'}
          on_close={()=>set_modal(null)}
          on_overlay_click={()=>set_modal(null)}>
            <Readonly_modal modal_plan_id={modal_plan_id}/>
        </Modal>
      </div>
    </>;
};
